import DashboardLayout from "@/packages/dashboard/views/DashboardLayout.vue";
import PurchaseAirtime from "@/packages/WaasModules/UtilityPayments/component/PurchaseAirtime.vue";
import PostPaidBillPayments from "@/packages/WaasModules/UtilityPayments/component/PostPaidBillPayments.vue";
import TVPayments from "@/packages/WaasModules/UtilityPayments/component/TVPayments.vue";
import PurchaseKPLCTokens from "@/packages/WaasModules/UtilityPayments/component/PurchaseKPLCTokens.vue";

const UtilityPaymentRoutes =[
    {
        path: '/dashboard/waas/utility-payments',
        component: DashboardLayout,
        children: [
            {
                path: 'purchase-airtime',
                component: PurchaseAirtime,
                name: "PurchaseAirtime",
                // meta: { middleware: [Auth]},
            },
            {
                path: 'post-paid-bills',
                component: PostPaidBillPayments,
                name: "PostPaidBillPayments",
                // meta: { middleware: [Auth]},
            },
            {
                path: 'purchase-kplc-tokens',
                component: PurchaseKPLCTokens,
                name: "KPLC",
                // meta: { middleware: [Auth]},
            },
            {
                path: 'tv',
                component: TVPayments,
                name: "TVPayments",
                // meta: { middleware: [Auth]},
            },
        ]
    }
];
export default UtilityPaymentRoutes;
